import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Modal, Message } from 'semantic-ui-react';

// Global Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';

// Global Actions
// @ts-ignore
import { updateQueryString } from 'services/router/actions';

// Global Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import EntityErrorsExistGate from 'components/EntityErrorsExistGate';
import QueryStringModal from 'components/QueryStringModal';

import { AppState } from 'services/types';
import { selectEntityErrorMessages } from 'services/entities/selectors';

// Local Components
import EntitiesSaveErrorForm from './components/EntitiesSaveErrorForm';

// Local Constants
import { ERROR_NAME_MUST_BE_UNIQUE, QUERY_STRING_PARAM } from './constants';

interface OwnProps {}

interface ConnectedProps {
    errors: ReturnType<typeof selectEntityErrorMessages>;
}

interface DispatchProps {
    updateQueryString: Function;
}

type Props = OwnProps & ConnectedProps & DispatchProps;

export const EntitiesSaveErrorModalComponent = (
    props: Props
): React.ReactElement => {
    const { errors } = props;

    const defaultMessage = (
        <p>
            Sorry, there was an unexpected error while uploading your recent
            changes. Please try again in a few minutes.
        </p>
    );

    const errorMessages = (
        <Message
            error
            header={`There ${
                errors.length === 1 ? 'was an error' : 'were some errors'
            }`}
            list={errors}
        />
    );

    const refresh = errors.some((e) => e.includes(ERROR_NAME_MUST_BE_UNIQUE));

    return (
        <EntityErrorsExistGate>
            <QueryStringModal
                param={QUERY_STRING_PARAM}
                modalProps={{
                    size: 'tiny',
                    onClose: () => {
                        if (refresh) {
                            props.updateQueryString({
                                [QUERY_STRING_PARAM]: undefined
                            });
                            window.location.reload();
                        }
                    },
                    closeOnDimmerClick: false
                }}
            >
                <ErrorBoundary
                    namespace="EntitiesSaveErrorModal"
                    FallbackComponent={<ErrorBoundaryAlert />}
                >
                    <Modal.Header>Areas upload failed</Modal.Header>
                    <Modal.Content>
                        {errors.length ? errorMessages : defaultMessage}
                        <p>
                            If the problem persists, please{' '}
                            <a href="mailto:mail@orchardhand.com">
                                contact Orchard Hand support
                            </a>
                            .
                        </p>
                        <EntitiesSaveErrorForm refresh={refresh} />
                    </Modal.Content>
                </ErrorBoundary>
            </QueryStringModal>
        </EntityErrorsExistGate>
    );
};

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    errors: selectEntityErrorMessages
});

export default connect(mapStateToProps, {
    updateQueryString
})(EntitiesSaveErrorModalComponent);
